import { Mapper } from "../../../../base/utils/mapper";
import { RevisionResponseModel } from "../../../../domain/models/consult/revision-response.model";
import { RevisionResponseEntity } from "../entities/revision-response.entity";


export class RevisionImplementationRepositoryMapper extends Mapper<RevisionResponseEntity, RevisionResponseModel> {
    mapFrom(param: RevisionResponseEntity): RevisionResponseModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: RevisionResponseModel): RevisionResponseEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}